import { StudentRequestApi } from "../DTO/ClientRequest/StudentRequest";
import {
  isStudentWithGroupsResponseDTO,
  StudentWithGroupsResponseApi,
} from "../DTO/ServerResponseType/Student/StudentWithGroups";

import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class StudentServerClient {
  private path = "/student";

  sendToRegistrateStudentAsync = async (
    student: StudentRequestApi & { groupCode: string }
  ): Promise<void> => {
    let url: string = serverOrigin + this.path + "/registration";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(student),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        alert("Учащийся успешно зарегистрирован. ");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });
  };

  sendToAddStudentToGroupAsync = async (
    studentId: string,
    newGroupCode: string
  ) => {
    let url: string = serverOrigin + this.path + "/addStudentToGroup";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        studentId: studentId,
        newGroupCode: newGroupCode,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        alert("Учащийся успешно зарегистрирован. ");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });
  };

  async sendToUpdateStudentAsync(studentData: {
    name: string;
    password: string | null;
    studentId: string;
  }) {
    let url: string = serverOrigin + this.path + "/update/all";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        studentId: studentData.studentId,
        studentNewData: {
          ...studentData,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        alert("Учащийся успешно изменен. ");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });
  }

  sendToGetStudentAsync = async (): Promise<
    | {
        studentName: string;
        studentPassword: string;
        groupCode: string;
      }
    | never
  > => {
    let url: string = serverOrigin + this.path + "/data";
    return await getTypeGuardedVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      function (variable: unknown): variable is {
        studentName: string;
        studentPassword: string;
        groupCode: string;
      } {
        return true;
      }
    ).catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    });
  };

  sendToGetAllStudentsAsync = async (): Promise<
    StudentWithGroupsResponseApi[]
  > => {
    let url: string = serverOrigin + this.path + "/show/all";
    return await getTypeGuardedArrayVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isStudentWithGroupsResponseDTO
    ).catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    });
  };

  sendToDisconnectStudentFromGroupAsync = async (
    studentId: string,
    groupId: string
  ) => {
    let url: string = serverOrigin + this.path + "/disconnect";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        studentId: studentId,
        groupId: groupId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then(() => {
        alert("Учащийся успешно отсоединен от группы. ");
      })
      .catch((error) => {
        console.log(error);
        alert("Произошла ошибка при удаление учащегося из группы. ");
      });
  };
}

let studentServerClient = new StudentServerClient();

export default studentServerClient;
